import { useEffect, useState } from "react";

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];
const STORAGE_KEY = "ym_utm_v1";

/**
 * Captures UTM params from the URL on first load (per session) and exposes them
 * along with document.referrer so forms can send attribution to the backend.
 */
export function useUTM() {
  const [utm, setUtm] = useState({
    source: "",
    medium: "",
    campaign: "",
    content: "",
    term: "",
  });
  const [referrer, setReferrer] = useState("");

  useEffect(() => {
    if (typeof window === "undefined") return;

    // Read existing snapshot
    let snapshot = null;
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      if (raw) snapshot = JSON.parse(raw);
    } catch (_) {
      snapshot = null;
    }

    // Look for utm_* in current URL
    const params = new URLSearchParams(window.location.search);
    const fromUrl = {};
    UTM_KEYS.forEach((k) => {
      const v = params.get(k);
      if (v) fromUrl[k.replace("utm_", "")] = v;
    });

    let next;
    if (Object.keys(fromUrl).length > 0) {
      next = {
        source: fromUrl.source || "",
        medium: fromUrl.medium || "",
        campaign: fromUrl.campaign || "",
        content: fromUrl.content || "",
        term: fromUrl.term || "",
      };
      try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      } catch (_) {
        /* storage may be blocked */
      }
    } else if (snapshot) {
      next = snapshot;
    } else {
      next = utm;
    }
    setUtm(next);
    setReferrer(document.referrer || "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { utm, referrer };
}
